import { SchemaTypes } from '@allesauto/graphql';
import { ParsedUrlQuery } from 'querystring';

import { AccessoriesUrlFilters } from '../types';

export const filterParseParams = (
  query: ParsedUrlQuery
): AccessoriesUrlFilters => {
  const filters: AccessoriesUrlFilters = {};

  if (query.brand) filters.brand = query.brand as string;
  if (query.model) filters.model = query.model as string;
  if (query.variant) filters.variant = query.variant as string;

  if (query.categoryId) {
    filters.categoryId = [];
    if (typeof query.categoryId === 'string') {
      filters.categoryId.push(query.categoryId);
    } else {
      filters.categoryId = [...query.categoryId];
    }
  }

  if (query.useCategory) filters.useCategory = query.useCategory as string;

  return filters;
};

// helper function that converts url filters to GQL query vars to filter it
export const filtersToQueryVariables = (
  filters: AccessoriesUrlFilters,
  accessoryBrands: SchemaTypes.AccessoryBrand[]
): SchemaTypes.AccessoryFilterOptions => {
  const variables: SchemaTypes.AccessoryFilterOptions = {
    dealerId: '',
  };

  if (filters.brand) {
    const brandItem = findBrandItem(accessoryBrands, filters.brand);
    variables.dealerId = brandItem?.dealerId || '';
  }

  if (filters.model) variables.model = filters.model;
  if (filters.variant) variables.variant = filters.variant;

  // Only query based on categories if the useCategory query is present
  if (filters.useCategory && filters.categoryId) {
    // Use last categoryId of the array for the query
    variables.categoryId =
      typeof filters.categoryId === 'string'
        ? filters.categoryId
        : filters.categoryId[filters.categoryId.length - 1];
  }

  return variables;
};

export const filtersToQueryVariablesAccessoriesSearch = (
  filters: AccessoriesUrlFilters,
  accessoryBrands: SchemaTypes.AccessoryBrand[]
): SchemaTypes.AccessorySearchOptions => {
  const variables: SchemaTypes.AccessorySearchOptions = {
    dealerId: '',
    query: '',
  };

  if (filters.brand) {
    const brandItem = findBrandItem(accessoryBrands, filters.brand);
    variables.dealerId = brandItem?.dealerId || '';
  }

  if (filters.model) variables.model = filters.model;
  if (filters.variant) variables.variant = filters.variant;

  // Only query based on categories if the useCategory query is present
  if (filters.useCategory && filters.categoryId) {
    // Use last categoryId of the array for the query
    variables.categoryId =
      typeof filters.categoryId === 'string'
        ? filters.categoryId
        : filters.categoryId[filters.categoryId.length - 1];
  }

  return variables;
};

// helper that finds a brand item either by distributor id or name
export const findBrandItem = (
  accessoryBrands: SchemaTypes.AccessoryBrand[],
  value: string | number | undefined
): SchemaTypes.AccessoryBrand | undefined => {
  return accessoryBrands.find(
    (item) => item.distributorId === value || item.name === value
  );
};
